module.exports = __webpack_public_path__ + "img/qycxzf-banner.0b135694.png";